import type { APPLICANT_ATTRIBUTION } from 'cpool-constants';
import { createId } from 'cpool-utils';

export const getExpenseDefaultValues = (attribution: APPLICANT_ATTRIBUTION) => ({
    betragMonatlich: null,
    gehoertZuAntragsteller: attribution,
    id: createId(),
});
